export const OUT_TRANSITION_TIME = 150;
